export const BASE_HANDLER_URL = process.env.REACT_APP_BASE_HANDLER_URL;
export const BASE_FILE_URL = process.env.REACT_APP_BASE_FILE_URL;

export const setUrl = (className, actionName, apifilter) => {
  const ApiFilter = `&userType=${sessionStorage.type}&CP=${sessionStorage.CP}&APPUSER=${sessionStorage.USER}&Reseller=${sessionStorage.Reseller}`;
  if (apifilter) {
    return `${BASE_HANDLER_URL}?class=${className}&action=${actionName}${ApiFilter}`;
  }
  return `${BASE_HANDLER_URL}?class=${className}&action=${actionName}`;
};

export const toTitleCase = (text) =>
  text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const isInputDisabled = () => {
  const viewOnly = sessionStorage.viewOnly?.toUpperCase();
  const type = sessionStorage.type?.toUpperCase();
  const fullAccess = sessionStorage.fullAccess?.toUpperCase();

  if (viewOnly === "N" && type === "IT" && fullAccess === "Y") return true;
  if (viewOnly === "N" && type === "M" && fullAccess === "Y") return false;
  return true;
};
